/**
 * @generated SignedSource<<8219b8bd333add1f7cdd13b421ee1e32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CalendarStartDay = "MONDAY" | "SUNDAY";
import { FragmentRefs } from "relay-runtime";
export type useGetClubStartOfWeekNumberPatron_club$data = {
  readonly calendarStartDay: CalendarStartDay;
  readonly " $fragmentType": "useGetClubStartOfWeekNumberPatron_club";
};
export type useGetClubStartOfWeekNumberPatron_club$key = {
  readonly " $data"?: useGetClubStartOfWeekNumberPatron_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetClubStartOfWeekNumberPatron_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetClubStartOfWeekNumberPatron_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "calendarStartDay",
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "36c30f6f4b50270d448835135a1dc55b";

export default node;
